import React, { useContext } from 'react'
import useFavurTranslation from 'hooks/useFavurTranslation'
import { ShareUserDataFormContext } from 'pages/Tasks/ShareUserData/Details'
import FramedIcon from 'redesign/components/atoms/FramedIcon'
import { PlaceholderIcon } from 'redesign/components/atoms/Icon'
import ContentCard from '../content-card'
import { TimelineItemContainer } from '../timeline-item/styles'
import type { TimelinePersonalDataFormProps } from './types'

const TimelinePersonalDataForm: React.FC<TimelinePersonalDataFormProps> = ({ tenantName, isOffice }) => {
  const { t } = useFavurTranslation()
  const { setShowForm } = useContext(ShareUserDataFormContext)

  return (
    <TimelineItemContainer data-testid="timeline-personal-data-form">
      <ContentCard
        onClick={isOffice ? undefined : () => setShowForm(true)}
        header={{
          icon: <FramedIcon icon={PlaceholderIcon} />,
          title: t('shareUserData.timeline.formCta'),
          titleTestId: 'timeline-personal-data-form-title',
          subtitle: tenantName,
          subtitleTestId: 'timeline-personal-data-form-subtitle',
          showChevron: true,
        }}
        hasBorder={false}
      />
    </TimelineItemContainer>
  )
}

export default TimelinePersonalDataForm
